import VacancyDetailsDrawer from "@/features/vacancies/components/details/VacancyDetailsDrawer";
import { VacancyDetailProvider } from "@/lib/contexts/Vacancy/VacancyDetailProvider";
import { useVacancyDetail } from "@/lib/hooks/useVacancyDetail";

type SegmentVacancyDrawerProps = {
  clientId?: string;
  vacancyId: number;
};

export function SegmentVacancyDrawer({
  clientId,
  vacancyId,
}: SegmentVacancyDrawerProps) {
  return (
    <VacancyDetailProvider clientId={clientId} vacancyId={String(vacancyId)}>
      <SegmentVacancyDetails clientId={clientId} />
    </VacancyDetailProvider>
  );
}

function SegmentVacancyDetails({
  clientId,
}: Pick<SegmentVacancyDrawerProps, "clientId">) {
  const { vacancy, vacancyLoading, vacancyFetching } = useVacancyDetail();

  return (
    <VacancyDetailsDrawer
      clientId={clientId}
      vacancy={vacancy}
      isLoading={vacancyLoading}
      isFetching={vacancyFetching}
    />
  );
}
